import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FaChevronLeft, FaChevronRight, FaQuoteRight, FaStar } from 'react-icons/fa';
import testimonials from '../../Data/testimonials';
import './CustomerComment.css';

function getPerPage(width) {
  if (width < 640) return 1;
  if (width < 992) return 2;
  return 3;
}

function chunkItems(items, size) {
  const pages = [];
  for (let i = 0; i < items.length; i += size) {
    pages.push(items.slice(i, i + size));
  }
  return pages;
}

const TestimonialCard = ({ item }) => (
  <li className="testimonial-card">
    <div className="testimonial-card-top">
      <div className="testimonial-stars" aria-label="5 yıldız">
        {[...Array(5)].map((_, i) => (
          <FaStar key={i} className="testimonial-star" aria-hidden />
        ))}
      </div>
      <FaQuoteRight className="testimonial-quote-icon" aria-hidden />
    </div>

    <blockquote className="testimonial-text">&ldquo;{item.text}&rdquo;</blockquote>

    <div className="testimonial-divider" aria-hidden />

    <footer className="testimonial-author">
      <cite className="testimonial-name">{item.customerName}</cite>
      <span className="testimonial-location">{item.location}</span>
    </footer>
  </li>
);

const CustomerComment = () => {
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(() => getPerPage(window.innerWidth));

  useEffect(() => {
    const onResize = () => setPerPage(getPerPage(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const pages = useMemo(() => chunkItems(testimonials, perPage), [perPage]);
  const totalPages = pages.length;

  useEffect(() => {
    setPage((p) => Math.min(p, Math.max(0, totalPages - 1)));
  }, [totalPages]);

  const goTo = useCallback(
    (next) => {
      setPage((p) => {
        if (next < 0) return totalPages - 1;
        if (next >= totalPages) return 0;
        return next;
      });
    },
    [totalPages]
  );

  const prev = () => goTo(page - 1);
  const next = () => goTo(page + 1);

  return (
    <section className="testimonials section" aria-labelledby="testimonials-heading">
      <div className="section-inner">
        <div className="testimonials-header">
          <span className="testimonials-eyebrow">Müşteri Yorumları</span>
          <h2 id="testimonials-heading" className="testimonials-title">
            Bursa&apos;lı Müşterilerimiz Ne Diyor?
          </h2>
          <p className="testimonials-subtitle">
            Binlerce müşterimizin güvendiği teknik servis ekibi.
          </p>
        </div>

        <div className="testimonials-carousel">
          <button
            type="button"
            className="testimonials-nav testimonials-nav--prev"
            onClick={prev}
            aria-label="Önceki yorumlar"
          >
            <FaChevronLeft aria-hidden />
          </button>

          <div className="testimonials-viewport" aria-live="polite">
            <ul
              className="testimonials-track"
              style={{ transform: `translateX(-${page * 100}%)` }}
            >
              {pages.map((group, pageIndex) => (
                <li className="testimonials-slide" key={pageIndex}>
                  <ul className="testimonials-grid">
                    {group.map((item) => (
                      <TestimonialCard item={item} key={item.id} />
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>

          <button
            type="button"
            className="testimonials-nav testimonials-nav--next"
            onClick={next}
            aria-label="Sonraki yorumlar"
          >
            <FaChevronRight aria-hidden />
          </button>
        </div>

        <div className="testimonials-footer">
          <div className="testimonials-dots" role="tablist" aria-label="Yorum sayfaları">
            {pages.map((_, i) => (
              <button
                key={i}
                type="button"
                role="tab"
                className={`testimonials-dot${i === page ? ' is-active' : ''}`}
                aria-label={`Yorum grubu ${i + 1}`}
                aria-selected={i === page}
                onClick={() => setPage(i)}
              />
            ))}
          </div>
          <p className="testimonials-counter">
            {page + 1} / {totalPages}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CustomerComment;
